var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectricity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#e6007e;fill-rule:evenodd;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M15.25,1.5l-.584,1L9.762,11H17.67l-1.15,2h-.006l-5.48,9.492L8.72,22.5l.464-.8L14.2,13H6.3l1.15-2h0L12.934,1.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricity);
export default __webpack_public_path__ + "static/media/electricity.e44a43570356c15446f258afc44122c6.svg";
export { ForwardRef as ReactComponent };